import { GetMerchantsType, GetFollowUpStatuses, GetMerchantsSources, GetCompanyTypes, GetPromotionCompany, GetMerchantsOwner, GetStates, GetBrandsSelection  } from "../api";
export default {
    data() {
        return {
            sourceOptions: [],
            merchantTypesOptions: [],
            companyOptions: [],
            promotionCompanyOptions: [],
            followUpStatusOptions: [],
            ownersOptions: [],
            stateOptions: [],
            brandOptions:[],
        }
    },
    created() {
        this.getMerchantsSourece();
        this.getMerchantsType();
        this.getComponyType();
        this.getPromotionCompany();
        this.getFollowUpStatuses();
        this.getOwners();
        this.getStatesOptions();
        this.getBrandOptions();
    },
    methods: {
        getBrandOptions() {
            return new Promise((resolve, reject) => {
              GetBrandsSelection()
                .then((res) => {
                  this.brandOptions = res.data;
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                  this.$message.error(err.response.data.message);
                });
            });
          },
        getMerchantsSourece() {
            return new Promise((resolve, reject) => {
                GetMerchantsSources()
                    .then((res) => {
                        this.sourceOptions = res.data;
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取表单类型失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getMerchantsType() {
            return new Promise((resolve, reject) => {
                GetMerchantsType()
                    .then((res) => {
                        this.merchantTypesOptions = res.data;
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取表单类型失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getComponyType() {
            return new Promise((resolve, reject) => {
                GetCompanyTypes()
                    .then((res) => {
                        this.companyOptions = res.data;
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取公司类型失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getPromotionCompany() {
            return new Promise((resolve, reject) => {
                GetPromotionCompany()
                    .then((res) => {
                        if (res.status === 200 || res.status === 206) {
                            this.promotionCompanyOptions = res.data;
                            resolve(res.data);
                        }
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取合作方数据失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getFollowUpStatuses() {
            return new Promise((resolve, reject) => {
                GetFollowUpStatuses()
                    .then((res) => {
                        this.followUpStatusOptions = res.data;
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取跟进状态数据失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getOwners() {
            return new Promise((resolve, reject) => {
                GetMerchantsOwner()
                    .then((res) => {
                        if (res.status === 200 || res.status === 206) {
                            this.ownersOptions = res.data;
                            resolve(res.data);
                        }
                    })
                    .catch((err) => {
                        reject();
                        console.error("获取跟进人数据失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
        getStatesOptions() {
            return new Promise((resolve, reject) => {
                GetStates({ unPaged: true })
                    .then((res) => {
                        if (res.status === 200 || res.status === 206) {
                            this.stateOptions = res.data.content;
                            resolve(res.data);
                        }
                    })
                    .catch((err) => {
                        reject(err)
                        console.error("获取阶段选单数据失败", err.response);
                        this.$message.error(err.response.data.message);
                    });
            });
        },
    }
}